import { render, staticRenderFns } from "./patients-form.vue?vue&type=template&id=3aa9558a&"
import script from "./patients-form.vue?vue&type=script&lang=js&"
export * from "./patients-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports